// extracted by mini-css-extract-plugin
module.exports = {"serviceCardList":"ServiceCardList_serviceCardList__1v8Ms","serviceCard":"ServiceCardList_serviceCard__TxM0G"};